<template>
  <div v-if="userCurrentReview">
    <div
      class="fe-flex fe-items-center fe-justify-between fe-mb-xs lg:fe-mb-base"
    >
      <div class="fe-text-heading-xxs lg:fe-text-heading-xs">My Review</div>
      <div>
        <CustomFdkAccount v-slot="accountsData">
          <JdsLink
            type="button"
            className="sm:fe-text-body-xs-link lg:fe-text-body-m-link"
            @click="openWriteReviewModal(accountsData)"
          >
            Edit
          </JdsLink>
        </CustomFdkAccount>
      </div>
    </div>
    <div>
      <ReviewListItem
        :isUserOwnReview="true"
        :review="userCurrentReview"
        :showApprovalPending="isPendingReview"
      />
    </div>
  </div>
</template>

<script>
  import JdsLink from "@/components/DesignSystem/JdsLink/JdsLink.vue"
  import ReviewListItem from "./ReviewListItem.vue"
  import CustomFdkAccount from "@/components/Utilities/CustomFdkAccount/CustomFdkAccount.vue"
  import AddEditReview from "@/components/ReviewAndRating/AddEditReview/AddEditReview.vue"
  import { modalMixin } from "@/mixins/modalMixin"
  import { customerLoginHandler } from "@/utils/utils"

  export default {
    name: "ReviewList",
    components: { ReviewListItem, JdsLink, CustomFdkAccount },
    mixins: [modalMixin],
    inject: ["globalState"], // top parent component state
    props: {
      isOpenInModal: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      userCurrentReview() {
        return this.globalState.userCurrentReview
      },
      isPendingReview() {
        return this.globalState.isPendingReview
      },
    },
    methods: {
      openWriteReviewModal(accountsData) {
        if (!accountsData.is_logged_in) {
          customerLoginHandler(accountsData)
        } else {
          this.openModal(AddEditReview)
        }
      },
    },
  }
</script>
